export enum DIALOG_TYPES {
  CREATE,
  EDIT,
  DELETE,
  RESET_PASSWORD
}
